/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_2_Term_UsInputs */

const en_terms_section_2_term_us = /** @type {(inputs: Terms_Section_2_Term_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“Lindevo”, “we”, “us”`)
};

const lv_terms_section_2_term_us = /** @type {(inputs: Terms_Section_2_Term_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Lindevo”, „mēs”`)
};

/**
* | output |
* | --- |
* | "“Lindevo”, “we”, “us”" |
*
* @param {Terms_Section_2_Term_UsInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_2_term_us = /** @type {((inputs?: Terms_Section_2_Term_UsInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_2_Term_UsInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_2_term_us(inputs)
	return en_terms_section_2_term_us(inputs)
});